import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   allProductionStatus: [],
   activeStatus: null,
   isLoading: false,
   isFirstLoading: false,
   mainTableExpanded: null,
   mainLocationTableData: [],
   page: 0,
   dataCount: 0,
   offset: 0,
   dataPerPage: 15,
   wrappingSelectedRowData: null,
   auditSelectedRowData: null,
   verificationSelectedRow: null,
   productionTableActionTrigger: false,
   productCountChangeActionTrigger: false,
   languageOption: [
      {
         label: "English",
         value: "en",
      },
      {
         label: "Spanish",
         value: "es",
      }
   ],
   selectedLanguage: "en"
};
export const ProductionSlice = createSlice({
   name: "Production",
   initialState: initialState,
   reducers: {
      setAllProductionStatus: (state, action) => {
         state.allProductionStatus = action.payload;
      },
      setActiveStatus: (state, action) => {
         state.activeStatus = action.payload;
      },
      setIsLoading: (state, action) => {
         state.isLoading = action.payload;
      },
      setIsFirstLoading: (state, action) => {
         state.isFirstLoading = action.payload;
      },
      setMainTableExpanded: (state, action) => {
         state.mainTableExpanded = action.payload;
      },
      setMainLocationTableData: (state, action) => {
         state.mainLocationTableData = action.payload;
      },
      setWrappingSelectedRowData: (state, action) => {
         state.wrappingSelectedRowData = action.payload;
      },
      setAuditSelectedRowData: (state, action) => {
         state.auditSelectedRowData = action.payload;
      },
      setVerificationSelectedRow: (state, action) => {
         state.verificationSelectedRow = action.payload;
      },
      setProductionTableActionTrigger: (state, action) => {
         state.productionTableActionTrigger = action.payload;
      },
      setProductCountChangeActionTrigger: (state, action) => {
         state.productCountChangeActionTrigger = action.payload;
      },
      handleProductionWrappingModalClose: (state, action) => {
         state.wrappingSelectedRowData = null;
         if (state.activeStatus !== "COMPLETED_WRAP") {
            state.productionTableActionTrigger = true;
            state.productCountChangeActionTrigger = true;
         }
      },
      changeLanguage: (state, action) => {
         state.selectedLanguage = action.payload;
      },
      handleVerificationModalClose: (state, action) => {
         state.verificationSelectedRow = null;
         state.productionTableActionTrigger = true;
         state.productCountChangeActionTrigger = true;
      },
      setPageConfigData: (state, action) => {
         switch (action.payload.type) {
            case "SET_PAGE":
               state.page = action.payload.data;
               break;
            case "SET_DATA_COUNT":
               state.dataCount = action.payload.data;
               break;
            case "SET_IS_LOADING":
               state.isLoading = action.payload.data;
               break;
            case "SET_DATA_PER_PAGE":
               state.dataPerPage = action.payload.data;
               break;
            case "SET_OFFSET":
               state.offset = action.payload.data;
               break;
            default:
               break;
         }
      },
   },
});

export const {
   setActiveStatus,
   setAuditSelectedRowData,
   setVerificationSelectedRow,
   setProductionTableActionTrigger,
   setProductCountChangeActionTrigger,
   setWrappingSelectedRowData,
   handleProductionWrappingModalClose,
   handleVerificationModalClose
} = ProductionSlice.actions;
